const angular = require('angular');
const app = angular.module('learn-resources');

function unserialized_response_to_caller(data, headersGetter, status) {
    return {data: data, headers: headersGetter, status: status};
}

/**
 * Reports Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('Reports', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
        return $resource(appConfiguration.apiUrl + '/learn/v3/reports/:subresource', null, {
            list: {params: {subresource: 'list'}, method: 'GET', isArray: true}
        });
    }]
);
// /reports/user-engagemet/:year/:month/:day/csv
app.factory('ReportsResources', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
        return $resource(appConfiguration.apiUrl + '/learn/v3/reports/:report/:year/:month/:day/:type', null, {
            csv: {
                params: {type: 'csv'},
                method: 'POST',
                isArray: false,
                responseType: 'arraybuffer',
                transformResponse: unserialized_response_to_caller
            }
        });
    }]
);

/**
 * ReportsService Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('ReportsService', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
  return $resource(appConfiguration.reportsUrl + '/api/v1/reports/:report/:from/:until', null, {
    create: {method: 'POST', isArray: true}
  });
}]);

/**
 * CustomReportQueryService Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('CustomReportQueryService', ['$resource', 'appConfiguration', function($resource, appConfiguration) {
    return $resource(appConfiguration.apiUrl + '/learn/v3/custom-reports/:subresource/:action', null, {
      get: {params: {subresource: ''}, method: 'GET', isArray: false},
      find: {params: {subresource: ''}, method: 'GET', isArray: false},
      create: {params: {}, method: 'POST', isArray: false},
      update: {params: {subresource: ''}, method: 'POST', isArray: false},
      duplicate: {params: {subresource: '', action: 'duplicate'}, method: 'POST', isArray: false},
      remove: {params: {subresource: ''}, method: 'DELETE', isArray: false}
    });
  }]
);